import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as mixins from '~utils/mixins';
export const editor = theme => ({
  p: 2,
  background: theme.plain.backgroundColor,
  borderTop: 0,
  fontFamily: 'monospace',
  fontSize: 18,
  '* > textarea:focus': {
    outline: 'none'
  }
});

if (typeof editor !== 'undefined' && editor && editor === Object(editor) && Object.isExtensible(editor) && !editor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(editor, '__filemeta', {
    configurable: true,
    value: {
      name: "editor",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const error = {
  m: 0,
  py: 2,
  px: 3,
  bg: '#FF4757',
  fontSize: 1,
  color: 'white',
  whiteSpace: 'pre-wrap'
};

if (typeof error !== 'undefined' && error && error === Object(error) && Object.isExtensible(error) && !error.hasOwnProperty('__filemeta')) {
  Object.defineProperty(error, '__filemeta', {
    configurable: true,
    value: {
      name: "error",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const previewWrapper = {
  position: 'relative'
};

if (typeof previewWrapper !== 'undefined' && previewWrapper && previewWrapper === Object(previewWrapper) && Object.isExtensible(previewWrapper) && !previewWrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(previewWrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "previewWrapper",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const wrapper = () => ({
  height: 'auto',
  display: 'block',
  minHeight: '100%',
  width: 'calc(100% - 2px)',
  bg: 'playground.bg'
});

if (typeof wrapper !== 'undefined' && wrapper && wrapper === Object(wrapper) && Object.isExtensible(wrapper) && !wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapper",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const wrapperBorder = (content, showingCode) => {
  let borderRadius = 4;

  if (showingCode) {
    borderRadius = content === 'preview' ? '4px 4px 0 0' : '0 0 4px 4px';
  }

  return {
    border: t => `1px solid ${t.colors.playground.border}`,
    borderTop: content === 'editor' ? 0 : undefined,
    borderRadius
  };
};

if (typeof wrapperBorder !== 'undefined' && wrapperBorder && wrapperBorder === Object(wrapperBorder) && Object.isExtensible(wrapperBorder) && !wrapperBorder.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapperBorder, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapperBorder",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const preview = {
  margin: 0,
  padding: '20px'
};

if (typeof preview !== 'undefined' && preview && preview === Object(preview) && Object.isExtensible(preview) && !preview.hasOwnProperty('__filemeta')) {
  Object.defineProperty(preview, '__filemeta', {
    configurable: true,
    value: {
      name: "preview",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const buttons = {
  zIndex: 9,
  display: 'flex',
  position: 'absolute',
  bottom: -20,
  right: 4
};

if (typeof buttons !== 'undefined' && buttons && buttons === Object(buttons) && Object.isExtensible(buttons) && !buttons.hasOwnProperty('__filemeta')) {
  Object.defineProperty(buttons, '__filemeta', {
    configurable: true,
    value: {
      name: "buttons",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const button = _objectSpread(_objectSpread({}, mixins.ghostButton), {}, {
  display: 'flex',
  alignItems: 'center',
  py: 1,
  p: 2,
  bg: 'border',
  color: 'muted',
  borderRadius: '0 0 3px 3px',
  '& ~ &': {
    ml: 1
  }
});

if (typeof button !== 'undefined' && button && button === Object(button) && Object.isExtensible(button) && !button.hasOwnProperty('__filemeta')) {
  Object.defineProperty(button, '__filemeta', {
    configurable: true,
    value: {
      name: "button",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}

export const link = {
  py: 0,
  ml: 1,
  height: 22
};

if (typeof link !== 'undefined' && link && link === Object(link) && Object.isExtensible(link) && !link.hasOwnProperty('__filemeta')) {
  Object.defineProperty(link, '__filemeta', {
    configurable: true,
    value: {
      name: "link",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Playground/styles.js"
    }
  });
}